/**
 * Sentinel ids for the non-data virtual rows in the narrative list (pinned
 * divider + edge loaders). Negative so they can never collide with a real
 * narrative id (which are always positive), and each is distinct so the
 * virtualizer keys stay stable across renders.
 *
 * Where each row sits in the combined virtual list (top → bottom):
 *
 *   DESC (newest at top)          ASC (newest at bottom)
 *   --------------------          ----------------------
 *   pinned rows                   OLDER_LOADER   (-3)
 *   PINNED_DIVIDER (-1)           data (oldest -> newest)
 *   NEWER_LOADER   (-2)           NEWER_LOADER   (-2)
 *   data (newest -> oldest)       PINNED_DIVIDER (-1)
 *   OLDER_LOADER   (-3)           pinned rows
 *
 * The `newer` loader is always adjacent to the newest entry (just past the
 * pinned section); the `older` loader is always at the far/oldest end.
 */
export const PINNED_DIVIDER_ROW_ID = -1 as const;
export const NEWER_LOADER_ROW_ID = -2 as const;
export const OLDER_LOADER_ROW_ID = -3 as const;
